export { EpgItem } from './epg-item';
